// Supabase client — replaces Firebase. Reads REACT_APP_SUPABASE_* from .env
// File kept as firebase.js so existing imports (@/lib/firebase) require no changes.
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseReady = Boolean(supabaseUrl && supabaseKey);

export const supabase = supabaseReady
  ? createClient(supabaseUrl, supabaseKey, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : null;

// Legacy alias — components that import `firebaseReady` still compile
export const firebaseReady = supabaseReady;
